module.exports = __webpack_public_path__ + "static/media/admin.8ecc1151.png";